import React from "react";
import { Eye } from "lucide-react";
import styles from "../../styles/automation-styles";
import { Button, Grid } from "@mui/material";

// AutomationTemplateCard Component
const AutomationTemplateCard = ({
  automationTemplate,
  handleClickTitle,
  handleClickPreview,
}) => {

  return (
    <Grid item xs={6}>
      <Grid container>
        <Grid item spacing={2} xs={12} p={2} style={{ ...styles.card, borderRadius: '8px', marginBottom: 0 }}>

          <h3 style={{ ...styles.cardTitle, cursor: handleClickTitle ? 'pointer' : 'default' }}
            onClick={(e) => {
              e.preventDefault();
              if (handleClickTitle) {
                handleClickTitle(automationTemplate)
              }
            }}
          >
            {automationTemplate.index}. {automationTemplate.name}
          </h3>

          <p style={styles.cardCondition}>{automationTemplate.description}</p>

          <div style={{ ...styles.cardHeader, marginTop: "24px" }}>
            <Button
              data-tour="automation-template-preview-button"
              style={{
                ...styles.newRuleButton,
                fontSize: "12px",
                padding: "4px 8px",
              }}
              onClick={(e) => {
                e.preventDefault();
                if (handleClickPreview) {
                  handleClickPreview(automationTemplate)
                }
              }}
            >
              <Eye size={14} />

              <span>Pré-visualização</span>
            </Button>
          </div>

        </Grid>
      </Grid>
    </Grid>
  );
};

export default AutomationTemplateCard;